import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  showPrice?: boolean;
}
export function CTAButton({
  children = 'Descargar el Protocolo',
  className = '',
  onClick,
  fullWidth = false,
  showPrice = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const target = document.getElementById('comprar');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <div className={`flex flex-col items-center ${fullWidth ? 'w-full' : 'w-auto'}`} data-id="element-1">
      <motion.button whileHover={{
      scale: 1.02,
      filter: 'brightness(1.1)'
    }} whileTap={{
      scale: 0.98
    }} initial={{
      boxShadow: '0 0 0 rgba(165, 36, 34, 0)'
    }} animate={{
      boxShadow: ['0 4px 14px 0 rgba(165, 36, 34, 0.3)', '0 4px 20px 0 rgba(165, 36, 34, 0.5)', '0 4px 14px 0 rgba(165, 36, 34, 0.3)']
    }} transition={{
      boxShadow: {
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }} onClick={handleClick} className={`
          relative overflow-hidden
          bg-[#A52422] text-white font-semibold uppercase tracking-wide
          min-h-[48px] py-3 sm:py-4 px-6 sm:px-8 rounded-lg
          transition-all duration-300
          flex items-center justify-center gap-2
          group
          ${fullWidth ? 'w-full' : 'w-auto'}
          ${className}
        `} style={{
      fontSize: 'var(--text-sm)'
    }} data-id="element-2">
        <span className="relative z-10 flex items-center gap-2 justify-center text-center" data-id="element-3">
          <span data-id="element-4">{children}</span>
        </span>
        <ArrowRight className="w-5 h-5 relative z-10 shrink-0 group-hover:translate-x-1 transition-transform duration-300" data-id="element-5" />

        {/* Subtle gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none" data-id="element-6" />
      </motion.button>

      {showPrice && <div className="flex items-center gap-2 mt-3 justify-center" data-id="element-7">
          <span className="line-through" style={{
        fontSize: 'var(--text-sm)',
        color: '#999999'
      }} data-id="element-8">
            $19.99
          </span>
          <span className="font-bold" style={{
        fontSize: 'var(--text-xl, 1.25rem)',
        color: '#FFFFFF'
      }} data-id="element-9">
            $6.39
          </span>
          <span className="font-semibold rounded-md px-2 py-0.5" style={{
        fontSize: 'var(--text-xs, 0.75rem)',
        backgroundColor: 'rgba(74, 222, 128, 0.15)',
        color: '#4ade80'
      }} data-id="element-10">
            68% OFF
          </span>
        </div>}
    </div>;
}